<template>
  <button
      :class="buttonClasses"
      @click="handleClick"
  >
    {{label}}
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    },
    primary: {
      type: Boolean,
      default: false
    },
    secondary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonClasses() {
      return {
        'st-btn': true,
        'st-btn-primary': this.primary,
        'st-btn-secondary': this.secondary,
        'st-btn-disabled': this.disabled
      };
    }
  },
  methods: {
    handleClick(event) {
      if (!this.disabled) {
        this.$emit('click', event);
      }
    }
  }
};
</script>

<style scoped>
.st-btn {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 700;
  height: 40px;
}
.st-btn-primary {
  background-color: var(--primary-color-new);
  color: white;
}
.st-btn-secondary {
  background-color: gray;
  color: white;
}
.st-btn-disabled {
  background-color: lightgray;
  color: darkgray;
  cursor: not-allowed;
}
</style>
